module.exports = __webpack_public_path__ + "img/difficulty-2-stars.c93dd4b6.png";